import { isLocalStorageAvailable } from "../../utils"

const bmiLength = "bmi-length"
const bmiWeight = "bmi-weight"

interface UseBmi {
	getLength: () => number
	getWeight: () => number
	setLength: (length: number) => void
	setWeight: (weight: number) => void
}

export const useBmi = (): UseBmi => {
	const getLength = () => {
		return isLocalStorageAvailable()
			? parseInt(localStorage.getItem(bmiLength), 10)
			: 0
	}
	const getWeight = () => {
		return isLocalStorageAvailable()
			? parseInt(localStorage.getItem(bmiWeight), 10)
			: 0
	}
	const setLength = (length: number) => {
		if (isLocalStorageAvailable()) {
			localStorage.setItem(bmiLength, String(length))
		}
	}
	const setWeight = (weight: number) => {
		if (isLocalStorageAvailable()) {
			localStorage.setItem(bmiWeight, String(weight))
		}
	}
	return {
		getLength,
		getWeight,
		setLength,
		setWeight,
	}
}
